// extracted by mini-css-extract-plugin
export var caution = "InputTextareaFieldMin-module--caution--98201";
export var container = "InputTextareaFieldMin-module--container--c81b1";
export var counter = "InputTextareaFieldMin-module--counter--ee611";
export var message = "InputTextareaFieldMin-module--message--75dbc";
export var textarea = "InputTextareaFieldMin-module--textarea--f006e";